angular.module('CarsSaraBo').controller('ApplicationController',
    ['$scope', '$rootScope', '$filter', '$location', '$timeout', 'SecurityUserService', 'LogoutService', 'CompanyService', '$cookieStore', 'LoadingWheelService',
        'NotificationService', 'ModalService', 'SessionService', 'SidebarService', 'InformationModalService','BackgroundColorService',
        '$window', 'EmailValidatorService',
        function ($scope, $rootScope, $filter, $location, $timeout, securityUserService, logoutService, companyService, $cookieStore, loadingWheelService,
                  notificationService, modalService, sessionService, sidebarService, informationModalService, backgroundColorService, $window, emailValidatorService) {

            // TODO: sacar rentadora 37 xq es solo para pruebas
            const NOTIFICATIONS_ENABLED = false;
            const COMPANIES_ENABLED_FOR_NOTIFICATIONS = [37, 426, 735, 845, 44, 666, 180, 782, 686, 81, 866, 271, 98, 174, 129, 533, 534, 467, 60, 729, 35, 66, 126, 948, 74, 45, 73, 65, 862, 103, 352, 377, 389, 669, 547, 132, 372, 471, 823, 353, 134, 133, 517, 63, 381, 893, 588, 806, 644, 826, 312, 913, 659, 822, 402, 660, 657, 69, 437, 522, 829, 587, 16, 846, 528, 530, 532, 279, 614, 25, 693, 661, 705, 64, 620, 637, 314, 249, 156, 848, 901, 711, 843, 573, 232, 601, 844, 343, 564, 796, 201, 210, 251, 645, 814, 896, 952, 222, 526, 562, 604, 819, 827, 853, 867, 874, 884, 886, 930, 940, 956, 618, 678, 653, 538, 579, 790, 904, 632, 662, 887, 236, 912, 871, 879, 921, 619, 858, 759, 730, 919, 320, 739, 942, 929, 713, 849, 804, 728, 270, 306, 466, 296, 616, 341, 717, 900, 304, 408, 147, 551, 337, 831, 636, 770, 798, 834, 850, 149, 325, 127, 749, 404, 346, 405, 777, 365, 278, 230, 794, 112, 511, 746, 816, 802, 916, 755, 852, 761, 875, 701, 809, 762, 758, 957, 958, 959];

            $scope.initialize = function () {
                $scope.modal = null;
                $rootScope.loadingProcessesCount = 0;
                $scope.lockMultipleClick = false;
            }

            $scope.gotoPath = function (path) {
                var p = window[path];

                if (arguments.length > 1) {
                    for (i = 1; i < arguments.length; i++) {
                        p = p.replace(/:.*?\//, arguments[i]);
                    }
                }
                $location.path(p);
            }

            $scope.anySelected = function (object) {
                return Object.keys(object).some(function (key) {
                    return object[key] && object[key].checked == true;
                });
            }

            $scope.allSelected = function (object) {
                return Object.keys(object).every(function (key) {
                    return object[key] && object[key].checked == true;
                });
            }

            $scope.showProgressBar = function () {
                loadingWheelService.show();
            }

            $scope.hideProgressBar = function () {
                loadingWheelService.hide();
            }

            $rootScope.showProgressBar = function () {
                loadingWheelService.show();
            }

            $rootScope.hideProgressBar = function () {
                loadingWheelService.hide();
            }

            $rootScope.$watch('loadingProcessesCount', function (value) {
                if (value > 0) {
                    $scope.showProgressBar();
                    $scope.hasPendingProcesses = true;
                } else {
                    $scope.hideProgressBar();
                    $scope.hasPendingProcesses = false;
                }
            });

            $scope.setProcessesCount = function (count) {
                $rootScope.loadingProcessesCount = count;
            }

            $scope.notifyProcessComplete = function () {
                $rootScope.loadingProcessesCount--;
            }

            $scope.getTargetUrl = function () {
                return sessionService.getTargetUrl();
            }

            $scope.getUserInfo = function () {
                return sessionService.session;
            };

            $scope.setCompanyToRepresent = function (company) {
                sessionService.setCompanyToRepresent(company);
            };

            $scope.cleanCompanyToRepresent = function () {
                sessionService.cleanCompanyToRepresent();
            };

            $scope.cleanSession = function () {
                sessionService.cleanSession();
            };

            $rootScope.$on("$routeChangeSuccess", function (event, current, previous) {
                ga('set', 'page', $location.$$path);
                ga('send', 'pageview');
            });

            $scope.showModal = function (title, description, callback) {
                modalService.show(title, description, callback);
            };

            $scope.modalVisible = function () {
                return modalService.isModalVisible();
            };

            $scope.hideModal = function (executeCallback) {
                modalService.hide(executeCallback);
            };

            $scope.goToLogin = function (param) {
                // $window.location.href = "../login-atp3";
                if((!param || ($location.$$path === '/'))){
                    $window.location.href = "../login-atp3";
                } else {
                    $window.location.href = "../login-atp3?referer=" + param;
                }
            }

            $scope.goToUrl = function(redirect, companyId){
                if(!redirect){
                    if(!companyId){
                        $scope.goToImpersonate();
                    }else{
                        $scope.goToTargetUrl(companyId);
                    }
                }else{
                    $location.$$parse(redirect);
                }
            }

            $scope.goToImpersonate = function () {
                $location.path("/impersonate");
            }

            $scope.goToTargetUrl = function (companyOid) {
                var targetURL = $scope.getTargetUrl();
                if (targetURL == null) {
                    $scope.goToDefaultTargetUrl(companyOid);
                } else {
                    window.location.href = targetURL;
                }
            }

            $scope.goToDefaultTargetUrl = function (companyOid) {
                if (companyOid) {
                    if ($scope.loggedUserAllowed('PERM_BOOKING_VIEW')) {
                    $location.path("/company/" + companyOid + "/home");
                    } else if ($scope.loggedUserAllowed('PERM_ADMIN_DATA_VIEW')) {
                        $location.path("/company/" + companyOid);
                    }
                } else {
                    $scope.goToImpersonate();
                }
            }

            $scope.requiresAuthentication = function (url) {
                $rootScope.showSubMenu = false;
                // Is not one of these pages:
                var requireAuthentication = url.indexOf('/login') == -1
                        && url.indexOf('/internal-error') == -1
                    && url.indexOf('/logout') == -1;


                return requireAuthentication;
            };

            $scope.loggedUserAllowed = function (permission) {
                return sessionService.loggedUserAllowed(permission);
            };

            $rootScope.setIgnoreGlobalHttpErrorHandling = function (boolValue) {
                $rootScope.ignoreGlobalHttpErrorHandling = boolValue;
            };

            $rootScope.$on('$locationChangeStart', function (event, toUrl, fromUrl) {
                $rootScope.setIgnoreGlobalHttpErrorHandling(false);
                if ($scope.requiresAuthentication(toUrl)) {
                    sessionService.setTargetUrl(toUrl);

                    const onCompleteCallback = function() {
                        sidebarService.enableButtons();
                        backgroundColorService.setBackgroundState(toUrl);
                        $rootScope.$broadcast("$locationChangeSuccess");
                    };

                    if (!sessionService.isLoggedIn()) {
                        event.preventDefault();
                        var redirectParam = window.location.href;
                        securityUserService.get().$promise
                            .then(function (user) {
                                sessionService.initializeUser(user).then(onCompleteCallback());
                            }, function (error) {
                               $scope.cleanSession();
                               $scope.goToLogin(redirectParam);
                            });
                    }
                } else {
                    $scope.cleanSession();
                }
                backgroundColorService.setBackgroundState(toUrl);
            });

            $scope.notifyFormErrors = function (errors) {
                notificationService.notifyFormErrors(errors);
            };

            $rootScope.notifyErrorByCode = function (messageCode) {
                notificationService.notifyErrorByCode(messageCode);
            }

            $rootScope.notifyErrorByCodeWithParams = function (messageCode, params) {
                notificationService.notifyErrorByCodeWithParams(messageCode, params);
            }

            $rootScope.notifyErrorDetailByCodes = function (errorResponse) {
                notificationService.notifyFrontErrorDetailByCodes(errorResponse.data);
            }

            $rootScope.notifyFrontErrorDetailByCodes = function (errorList) {
                notificationService.notifyFrontErrorDetailByCodes(errorList);
            }

            $scope.getToast = function(){
                return notificationService.getToast();
            }

            $rootScope.resourceNotFound = function (errorKey) {
                // $scope.errorKey = errorKey; De momento no se muestra - Verificar como solucionar el reload de la pagina.
                $location.path("/resourceNotFound");
            }

            // TODO: borrar cuando todos los componentes dejen de usarlo. Deben utilizar NotificationService.notifyInfoByCode(msg)
            $rootScope.notifyInfoByCode = function (messageCode) {
                notificationService.notifyInfoByCode(messageCode);
            };

            $scope.getFirtLink = function (containerId) {
                firstAnchor = angular.element($('#' + containerId)).children()[0];
                return firstAnchor ? firstAnchor.href : "";
            }

            $scope.validAmountField = function (toValidate) {
                var amountPattern = /^\d*(,|\.){0,1}\d*$/;
                return amountPattern.test(toValidate);
            }
            $scope.validTextField = function (toValidate) {
                var textPattern = /^[a-zA-Za-zA-ZÀ-ÖØ-öø-ÿ0-90-9\s()_\/\-\.\,\;\+\""\*\&\#\°\:\!]+$/;
                return textPattern.test(toValidate);
            }
            $scope.parseValidAmount = function (amount) {
                return parseFloat(amount.replace(",","."));
            }

            $scope.validPercentageFieldTwoDecimalsPattern = /^[0-9]{1,3}([,.][0-9]{1,2})?$/;

            $scope.validPercentageFieldTwoDecimals = function (toValidate) {
                return $scope.validPercentageFieldTwoDecimalsPattern.test(toValidate);
            }

            $scope.validAmountFieldTwoDecimals = function (toValidate) {
                var amountPattern = /^[0-9]{1,8}([,.][0-9]{1,2})?$/;
                return amountPattern.test(toValidate);
            }

            $scope.customFormatDate = function (date, formatString) {
                if (!formatString) {
                    formatString = "dd/MM/yyyy"
                }
                return $filter("date")(date, formatString);
            };

            $scope.validateEmail = function (email) {
                return emailValidatorService.validate(email);
            };

            //TODO: ver directiva ClickAndWait antes de seguir usando esto!
            $scope.lockClickButton = function () {
                $scope.lockMultipleClick = true;
                $timeout(function () {
                    $scope.lockMultipleClick = false;
                }, 1000);
            };

            $scope.showNotificationsButton = function () {
                if(NOTIFICATIONS_ENABLED && sessionService.session) {
                    return sessionService.session.userType === 'COMPANY' && COMPANIES_ENABLED_FOR_NOTIFICATIONS.indexOf(sessionService.session.companyOid) != -1;
                }
                return false;
            };

            $scope.getInformationModal = function(){
                return informationModalService;
            };


            /*
            * Agregados por refactor a componentes
            * */
            $scope.showLoadingWheel = function () {
                return loadingWheelService.loading;
            };

            $scope.getNotificationError = function () {
                return notificationService.notificationError;
            };

            $scope.getNotificationInfo = function () {
                return notificationService.notificationInfo;
            };

            $scope.getNotificationErrorDetails = function () {
                return notificationService.notificationErrorDetails;
            };

            $scope.getModal = function () {
                return modalService.modal;
            };

            $scope.isLoggedIn = function () {
                return sessionService.isLoggedIn();
            };

            $scope.isSidebarVisible = function () {
                return sidebarService.getIsVisible();
            };

            $scope.getSidebarConfig = function () {
                return sidebarService.getConfig();
            };

            $scope.getSession = function () {
                return sessionService.session;
            };

            $scope.initialize();
        }]);









//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/application_controller.js
// module id = 895
// module chunks = 3